export default __webpack_public_path__ + "static/media/ellipse-bottom-left.43e11e56.svg";